import io from 'socket.io-client';
import {constant} from '../../common/constant';
import {Encryption, Decryption} from 'ubs-framework/v2/common/function'
import {eraseCookie, getCookie} from 'ubs-framework/v2/common/function';
import {showToastError} from 'ubs-framework/v2/common/function';

let socket;
export {socket}
export const socketConnect = (dispatch, next, history) => {
    socket = io.connect(`${process.env.REACT_APP_ACCOUNT_SOCKET_URL}?token=${getCookie('ubs_token')}&flag=Account`, {
        "transports": ['websocket']
    })
    socket.on('connect', () => {
        dispatch({type: 'SOCKET_CONNECTION', payload: socket.id})
        next(socket.connected)
    })
    socket.on('response', response => {
            let res;
            if (typeof response === 'string') res = Decryption(response)
            else res = response
            console.log('response ===>', res);
            // Force-logout broadcasts are owned by the framework's UForceLogout component.
            // Yield here so we don't run the legacy alert / 401 redirect alongside the popup.
            if (res && res.data && res.data.forceLogout === true) {
                try { window.dispatchEvent(new CustomEvent('ubs:force-logout', { detail: res })); } catch (e) { /* dispatch must not block */ }
                return;
            }
            if (!res.error) {
                if (res.data.error) {
                    alert(res.data.error);
                } else {
                    switch (res.event) {
                        case 'login':
                            if (!res.data.activateAccount) {
                                dispatch({type: 'LOGIN', payload: res.data});
                                dispatch({type: 'AUTHENTICATE', payload: res?.data})
                                // Fetch pending payment status for billing banner
                                // sendData(dispatch, 'billing|cashfree|subscription|resumePayment', {});
                            }
                            break;
                        case 'authenticate':
                            dispatch({type: 'LOGIN', payload: res.data});
                            dispatch({type: 'AUTHENTICATE', payload: res?.data, isAdmin: res?.data?.isAdmin})
                            dispatch({type: 'SET_IS_ADMIN', payload: res?.data?.isAdmin})
                            // Fetch pending payment status for billing banner
                            sendData(dispatch, 'billing|cashfree|subscription|resumePayment', {});
                            break;
                        // Enriched events — store paymentMethodInfo globally for card expiry warnings
                        case 'billing|cashfree|subscription|fetch': {
                            if (res?.data?.paymentMethodInfo !== undefined) {
                                dispatch({ type: 'SET_PAYMENT_METHOD_INFO', payload: res?.data?.paymentMethodInfo });
                            }
                            break;
                        }
                        case 'billing|cashfree|subscription|lastSubscription': {
                            if (res?.data?.paymentMethodInfo !== undefined) {
                                dispatch({ type: 'SET_PAYMENT_METHOD_INFO', payload: res?.data?.paymentMethodInfo });
                            }
                            break;
                        }
                        case 'billing|cashfree|subscription|resumePayment': {
                            const rpAction = res?.data?.action;
                            switch (rpAction) {
                                case 'RESUME_AUTH':
                                case 'BANK_APPROVAL_PENDING':
                                case 'RESUME_PAYMENT_METHOD_UPDATE':
                                case 'RESUME_PAYMENT':
                                case 'AUTH_SESSION_EXPIRED':
                                case 'PAYMENT_TERMINAL_RETRY_MODIFY':
                                case 'WAIT_FOR_NEXT_CYCLE':
                                case 'SHOW_UPCOMING_PAYMENT_REMINDER':
                                    dispatch({type: 'SET_PENDING_PAYMENT', payload: {action: rpAction, data: res?.data, statusLabel: res?.data?.statusLabel}});
                                    break;
                                case 'ALREADY_PAID_APPLIED':
                                case 'NO_PENDING_MODIFICATION':
                                case 'NO_PENDING_PAYMENT':
                                default:
                                    dispatch({type: 'SET_PENDING_PAYMENT', payload: {action: rpAction, data: res?.data, statusLabel: res?.data?.statusLabel}});
                                    break;
                            }
                            break;
                        }
                        case 'track|master|sampledata|remove':
                            dispatch({type: 'SET_SETUP_DONE', payload: {isLoading: false}});
                            dispatch({type: 'SET_SAMPLE_DATA', payload: false});
                            break;
                        default:
                            break;
                    }
                }
            } else {
                if (res.code === 406 && res.event === 'authenticate') {
                    showToastError(res?.data?.error || res?.data?.message);
                    if (getCookie('ubs-token')) window.location.href = '/workspace';
                    else window.location.href = '/login';
                } else if (res.code === 401 || (res.event === 'authenticate' && !res.data?.isUserMFASetup)) {
                    dispatch({ type: 'LOGOUT' }); if (localStorage.getItem('notification_token')) sendData('logout', { device_token: localStorage.getItem('notification_token') })
                    dispatch({ type: 'LOGOUT' });
                    localStorage.clear()
                    eraseCookie('ubs_token')
                    eraseCookie('signup_token')
                    eraseCookie('ubsTabId')
                    window.location.reload(true)
                }
            }
        }
    );
};

const prepareData = (event, data) => {
    console.log(`(((${event})))`, data);
    return Encryption({event, data})
};

export const sendData = (dispatch, en, data) => {
    if (socket.connected) socket.emit('request', prepareData(en, data));
}
export const responseHandler = (response) => {
    let res;
    if (typeof response === 'string') res = Decryption(response)
    else res = response
    return res;
}
